import React from 'react';

import { Box, Typography } from '@mui/material';

import { LereToursPricingSuggestion } from '../types';

function formatCurrency(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function formatSignedPercent(value: number | null): string {
  if (value == null) {
    return '—';
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}${(value * 100).toFixed(1)}%`;
}

function formatSignedCurrency(value: number | null): string {
  if (value == null) {
    return '—';
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function getChangeColor(actionType: string): string {
  if (actionType === 'surcharge') {
    return 'success.main';
  }
  if (actionType === 'discount') {
    return 'error.main';
  }
  return 'text.primary';
}

export default function ToursPricingFormatter({ row }: { row: LereToursPricingSuggestion }) {
  const changeColor = getChangeColor(row.suggested_action_type);

  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Original:
        </Typography>{' '}
        {formatCurrency(row.original_tour_price)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Change %:
        </Typography>{' '}
        <Typography component="span" variant="body2" color={changeColor} fontWeight="medium">
          {formatSignedPercent(row.suggested_price_change_percent)}
        </Typography>
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Change $:
        </Typography>{' '}
        <Typography component="span" variant="body2" color={changeColor} fontWeight="medium">
          {formatSignedCurrency(row.suggested_price_change_amount)}
        </Typography>
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          After:
        </Typography>{' '}
        {formatCurrency(row.after_price)}
      </Typography>
    </Box>
  );
}
